import CombatChapter from "@frog/source/models/CombatChapter.js"
import Chapter from "@frog/source/models/Chapter.js"

export default class Game {
    static update(game, delta) {
        if(game.chapter != undefined
        && game.chapter.update != undefined) {
            game.chapter.update(delta)
        }
    }
    static load(game) {
        if(game.chapter != undefined) {
            if(game.chapter.type == "combat"
            || game.chapter.type == undefined) {
                game.chapter = CombatChapter.load({
                    "chapter": game.chapter,
                    "player": game.player,
                    "gameslug": game.slug
                })
            } else if(game.chapter.type == "explore") {
                game.chapter = Chapter.load({
                    "chapter": game.chapter,
                    "player": game.player,
                    "gameslug": game.slug
                })
            }
        }
        return game
    }
    static save(game) {
        // console.log("Saving game...", game)
    }
}
